export const bookCall = () => {
  window.open("https://tidycal.com/pk4/inbound", "_blank", "noopener,noreferrer");
};
